import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setName
} from '../redux/userGroups'
import sweetalert from 'sweetalert2'

export default function * requestChangeUserGroupName (action) {
  const { userGroupId, name } = action.payload

  const optimisticAction = yield optimisticPut(setName({
    id: userGroupId,
    name,
  }))

  try {
    yield call(apiAction, 'RenameGroup', {
      groupId: userGroupId,
      name,
    })
  } catch (error) {
    if (error.code === 300) { // Duplicate
      const state = yield select()

      yield call(sweetalert, {
        text: state.kanbo.locale.messages['USER_GROUP_NAME_IN_USE'],
        type: 'info'
      })
    } else {
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}
